import React, { useRef } from "react"
import { useDispatch, useSelector } from "react-redux"
import { useLocation, useNavigate } from "react-router"

import { Button } from "components/Button"
import { Buttons, Card } from "components/Card/Card"
import PreviousButton from "components/Previous/PreviousButton"
import { Steps } from "components/Steps"
import { useStepper } from "components/Steps/hooks"
import {
  DermatoRecap,
  DermatoRecapHandle,
} from "containers/Survey/DermatoRecap"
import actionsSurvey from "containers/Survey/services/actions"
import { PATH } from "containers/Survey/models"
import { DERMATOSCOPE_VIDEO_PAGE, SURVEY_PAGE } from "core/constants"
import { useLanguage } from "locales"
import { SurveyStore, UploadDocStore } from "types/store"

const TeleexpertiseRecap: React.FC = () => {
  const dispatch = useDispatch()
  const navigate = useNavigate()
  const { languages } = useLanguage()
  const recapRef = useRef<DermatoRecapHandle>(null)
  // Retour depuis /patch : on réaffiche la page du résumé qui a été modifiée,
  // en rouvrant toutes les pages qui étaient déjà déverrouillées.
  const { state } = useLocation() as {
    state?: { step?: number; editableSteps?: number[] }
  }
  const { current, insideStep, totalInsideSteps, totalSteps } = useStepper()
  const { answers, questions } = useSelector(
    ({ survey }: { survey: SurveyStore }) => survey,
  )
  const capturedDermatoPhotos = useSelector(
    ({ upload }: { upload: UploadDocStore }) => upload.capturedDermatoPhotos ?? [],
  )
  const capturedPhonePhotos = useSelector(
    ({ upload }: { upload: UploadDocStore }) => upload.capturedPhonePhotos ?? [],
  )
  const allPhotos = [...capturedPhonePhotos, ...capturedDermatoPhotos]

  const previousStep = () => {
    if (recapRef.current?.goBack()) return

    dispatch(actionsSurvey.jumpTo(PATH.dermato_video_capture))
    navigate(DERMATOSCOPE_VIDEO_PAGE)
  }

  const continueStep = () => {
    if (recapRef.current?.goNext()) return

    dispatch(actionsSurvey.next())
    navigate(SURVEY_PAGE)
  }

  return (
    <>
      <Steps
        current={current}
        insideStep={insideStep}
        totalInsideSteps={totalInsideSteps}
        totalSteps={totalSteps}
      />
      <PreviousButton onClick={previousStep} />
      <Card
        title={languages.dermatoRecapTitle}
        doNotAnimateTitle
      >
        <DermatoRecap
          ref={recapRef}
          answers={answers}
          questions={questions}
          capturedPhotos={allPhotos}
          initialStep={state?.step ?? 0}
          initialEditableSteps={state?.editableSteps}
        />
        <Buttons>
          <Button type="primary" onClick={continueStep}>
            {languages.continue}
          </Button>
        </Buttons>
      </Card>
    </>
  )
}

export default TeleexpertiseRecap
